import React from 'react'
import style from '../../../styles/mystyle.module.css'
import { useTranslation } from 'next-i18next'
import { useRouter } from "next/router";
import axios from "axios";

import * as config from '../../../next.config.js'
import Image from 'next/image'
import {useQuery} from '@tanstack/react-query'
function Certificates({ entityId,statusIds }) {
    const { locale } = useRouter();
    const { t } = useTranslation("common")

    // const [lstMedicalDataCertificates, setLstMedicalDataCertificates] =useState([])
    const getEntityCertificates=()=>{
        let status = statusIds

        if (entityId) {
            return axios.get(`${config['basePath']}/api/registeration/entityCertificates/getCertificateFromCache`,
                {
                    params: {
                        lang: locale,
                        entityId: JSON.stringify([entityId]),
                        statusId: JSON.stringify(status)
                    }
                })
                .then((entityCertificates) => {
     
                    let tempData = entityCertificates.data.data
                    // setLstMedicalDataCertificates([...tempData])
                    return tempData

                }).catch(err => err)
        }
    }
    const info = useQuery({queryKey:['entityDetails-certificates',entityId],queryFn: getEntityCertificates})

    return (
        <>
            {
                info.data&&info.data.length ?
                    <>
                        <div className={style.SectionContainer}>
                            <div className={style.allcard}>

                                <div className={style.TitleandIcons} >
                                    <div> <Image className={style.icontitle} src={`${config.basePath}/assest/Certificates.png`} alt="certificates" width={50} height={50}/></div>
                                    <div className={style.hLine9 + " " + style.paddingZero} >{t("Certificates")} </div>
                                </div>
                                {
                                    info.data&&info.data.map((certificateItem,index) => {
                                        return (
                                            <React.Fragment key={index}>
                                                <div className={style.paragraphandIcons} style={{marginBottom:"0.5rem"}} >
                                                <div className={style.Circle} > </div>
                                                    {/* <div> <Image className={style.viewmedical} src={`${config.basePath}/assest/BackGroundOfferheader.svg`}   width={50} height={50} alt="certificates"/></div> */}
                                                    <p className={style.aboutText } style={{marginBottom:"0"}}>
                                                        <>
                                                            {certificateItem.certificate&&certificateItem.certificate.name} - {certificateItem.certificateMajors&&certificateItem.certificateMajors.name} - {certificateItem.country&&certificateItem.country.name} - {certificateItem.year}
                                                        </>
                                                        <br />

                                                    </p>
                                                </div>
                                            </React.Fragment>

                                        )
                                    })

                                }
                            </div>
                        </div>

                    </>
                    : ""
            }
        </>
    )
}

export default Certificates
